import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { MediaGalleryContent } from './index';

const StyledMediaModal = styled(Modal)`
  max-width: 960px;
  width: 100%;
  //height: 560px;
  
  background-color: #fff;
  margin: 100px auto 0;
  padding: 15px 8px;
  
  &>div {
    margin: 0;
  }
    
  .thumbnail-view-container {
      margin: 20px 0 0;
      .thumbnail-item-wrapper {
        .thumbnail-wrapper {
          .thumbnail-content {
            width: 173px;
            height: 118px;
          }
          .thumbnail-image {
            max-width: 173px;
            max-height: 118px;
          }
        }
      }
    }
  
  
  .thumbnail-item-wrapper {
    margin: 5px!important;
  }
  
  .modal-footer.flex {
    padding: 1rem;
  }
  
  .upload {
    .thumbnail-content {
      padding-top: 20px!important;
      font-size: 14px!important;
      
      img {
        width: 40px!important;
        height: 40px!important;
        margin-bottom: 15px!important;
      }
    }
  }
  
  .search-input-container {
    margin-top: 20px;
  }
  
  .modal-footer.flex.web {
    padding: 10px 0;
    
    button {
      height: 30px;
    }
  }
  
  @media screen and (max-width: 575px) {
    max-width: 320px;
  }
`;

const MediaGalleryModal = ({ onConfirm, parent, isOpen }) => (
  <StyledMediaModal isOpen={isOpen}>
    <MediaGalleryContent isModal onConfirm={onConfirm} parent={parent} />
  </StyledMediaModal>
);

MediaGalleryModal.propTypes = {
  onConfirm: PropTypes.func,
  parent: PropTypes.string,
  isOpen: PropTypes.bool,
};

export default MediaGalleryModal;
